import styled from 'styled-components'

export const OffersContainer = styled.div``
